module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA9UlEQVRYhe2WQQ2FMAyGKwEJSEDCk4CEJwEJOEACEiYBCUhAAkeSrks5bLdX4I2sgxCa/Jcla7+szb8C3CqYC2CqgfGro6U8ALAtMLGu9iCYBn0Aql+AWIAJmPoTMqkAdi4cRHQ+8YIbgV0XL+qBaX7EDFwOMIfzSLnxBkMoQpwZQmziZdt3CJ8C4Dq/J0jatNvUAEspi/o7tWACxupCADf6HFj51tgW2H5yvoD5zSeueMkBZm88XAj5phwAZnPRlIc0Zwu4EF5B04iWMhQdQmEjfEiaANjAsTmpWrH0+2UF+Ee7AGe8PSUAVmGjNTrCZrv4RbEC3JkdrBfm6moAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shitang/Gzzd.png
// module id = b+TG
// module chunks = 6